/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {RemovalPoint} from '../_models/removal-point';

export interface RemovalPointType {
  name: string;
  address: string;
  address2: string;
  mobilePhones: string[];
  newPhones: string[];
  phones: string[];
  township: number;
  townshipName: string;
  zip: string;
}

export function RPTypeFromRP(rp?: RemovalPoint): RemovalPointType | null {
  const rPT: RemovalPointType = {
    name: '',
    address: '',
    address2: '',
    mobilePhones: [],
    newPhones: [],
    phones: [],
    township: null,
    townshipName: '',
    zip: ''
  };

  if (rp) {
    rPT.name = rp.name;
    rPT.address = rp.address;
    rPT.address2 = rp.address2;
    rPT.mobilePhones = rp.mobilePhones.map(it => it.number);
    rPT.phones = rp.phones.map(it => it.number);

    if (rp._embedded && rp._embedded.township) {
      rPT.township = rp._embedded.township.id;
      rPT.townshipName = rp._embedded.township.name;
      rPT.zip = rp._embedded.township.zip;
    }
  }

  return rPT;
}
